import { useEffect, useState } from 'react';

export const useHasClassroomsInCurrentUrl = (): boolean => {
  const [hasClassrooms, setHasClassrooms] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname;
      const parts = pathname.split('/').filter((part) => part.length > 0);
      setHasClassrooms(parts.includes('classrooms'));
    }
  }, []);

  return hasClassrooms;
};
